export const parameters = { lcp: [], cls: [], inp: [] };

export const updateWebVitals = (metric) => {
  const key = metric.name.toLowerCase();
  if (parameters[key]) {
    parameters[key].push(metric.value);
  }
};

export const logWebVitals = (loggerApiCall) => {
  loggerApiCall('status=webVitals', 'info', parameters);
};
